module.exports = __webpack_public_path__ + "static/img/1.3efa2a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ban/1.png
// module id = EX7y
// module chunks = 1